import { Background } from "./Background";
import { Engine } from "./Engine";
import { Player } from "./Player";
import { Renderer } from "./Renderer";

export type UpdateContext = {
  bg: Background;
  localPlayer: Player;
};

export abstract class Entity {
  protected engine: Engine;
  x: number;
  y: number;

  constructor(engine: Engine, x: number, y: number) {
    this.engine = engine;
    this.x = x;
    this.y = y;
  }

  abstract update(ctx: UpdateContext): void;
  abstract render(r: Renderer): Promise<void> | void;
}
